import React from "react"
import { Container } from "reactstrap"
import * as s from "./style.module.css"
import useLabels from "../../utils/useLabels"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Text from "../Text"
import labels from "../LocalizationNew/const"
import LocalizationMap from "../LocalizationMap"

export default function LocalizationNew({ lang }) {
  const t = useLabels(labels, lang);

  return (
    <div className={s.root} id="lokalizacja">

      <Container className="my-3" >

        <div className={s.header}>
          <h2>Lokalizacja 2026</h2>
        </div>

        <div className={s.localizationWrapper}>

          <div className={s.imgWrapper}>
            <LazyLoadImage
              effect="blur"
              src={require('./images/lokalizacja.webp').default}
              alt="lokalizacja"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </div>

          <div className={s.textWrapper}>
            <Text title={t.gdansk.title} text={t.gdansk.desc} />
          </div>

        </div>

        <div className="mt-5">
          <LocalizationMap />
        </div>
      </Container>
    </div>
  )
}
